/**
 * Company branding for the dashboard surfaces (Commandment VIII - branding propagates end to end).
 *
 * Both the in-app read (GET /projects/:id/dashboard) and the public shared-link read return the same
 * object (backend services/dashboard/dashboardBranding.ts):
 *   { logoUrl: SAS URL | null, primaryColor: '#RRGGBB' (never null), palette: { primary }, font,
 *     fallbackUsed: { logo, palette, font } }
 * `fallbackUsed.x === true` means the backend substituted a platform default because the company has
 * not configured that part. A default is NOT the company's branding, so a fallback part is never
 * applied here (the surface stays neutral for it) and is reported in `unconfigured`, which drives the
 * "Company branding not configured" notice for Lead Advisors / Advisors.
 *
 * Only values safe for a style or an <img src> survive (hex colour, plain font name, http(s) URL).
 * Returns null only when the payload carries no branding object at all (nothing can be claimed then).
 */
const HEX_COLOUR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;
const FONT_FAMILY = /^[A-Za-z0-9][A-Za-z0-9 ._-]{0,63}$/;
const HTTP_URL = /^https?:\/\//i;

export function normaliseDashboardBranding(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const fb = raw.fallbackUsed && typeof raw.fallbackUsed === 'object' ? raw.fallbackUsed : {};
  const logo = typeof raw.logoUrl === 'string' && HTTP_URL.test(raw.logoUrl.trim()) ? raw.logoUrl.trim() : null;
  const colour = typeof raw.primaryColor === 'string' && HEX_COLOUR.test(raw.primaryColor.trim()) ? raw.primaryColor.trim() : null;
  const font = typeof raw.font === 'string' && FONT_FAMILY.test(raw.font.trim()) ? raw.font.trim() : null;
  return {
    logoUrl: fb.logo ? null : logo,
    primaryColor: fb.palette ? null : colour,
    fontFamily: fb.font ? null : font,
    unconfigured: [fb.logo && 'logo', fb.palette && 'colour', fb.font && 'font'].filter(Boolean),
  };
}
